// extracted by mini-css-extract-plugin
export default {"root__wrapper":"style-module__root__wrapper___tgi4h"};
    if(module.hot) {
      // 1697460472180
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  